package one.devsbox.shared.devices

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable
import one.devsbox.commons.EMPTY
import one.devsbox.commons.KdbLocalDateTimeSerializer
import one.devsbox.shared.msg.MessageBody

object IO {

    @Serializable
    data class DeviceSimple(
        var id: Long = 0,
        var key: String = "",
        var online: Boolean = false,
        @Serializable(with = KdbLocalDateTimeSerializer::class)
        var dtOnlineChange: LocalDateTime = LocalDateTime.EMPTY,
    ) {}

    @Serializable
    data class Registration(
        val device: Device,
        val host: Host
    ) {
        companion object {}

        @Serializable
        data class Host(
            val app: String,
            val msg: String,
            val res: String,
        ) {
            companion object {}
        }
    }

    @Serializable
    data class Device(
        var key: String = "",
        var online: Boolean = false,
        @Serializable(with = KdbLocalDateTimeSerializer::class)
        var dtOnlineChange: LocalDateTime = LocalDateTime.EMPTY,
        /**
         * syntax:
         * ``runtime.www``
         */
        var version: String = "0.0",
        var config: MessageBody.Config = MessageBody.Config()
    ) {}

    @Serializable
    data class Application(
        var id: Long = 0,
        var ip: String = "0.0.0.0",
        var version: Int = 0,
        var name: String = "",
        /**
         * - **4** -> ANDROID APP
         * - **8** -> WWW APP
         * @see ApplicationType
         */
        var type: Int = -1,
        var size: Long = -1,
    ) {}

    @Serializable
    data class Alive(
        var online: Boolean = false,
        @Serializable(with = KdbLocalDateTimeSerializer::class)
        var dt: LocalDateTime = LocalDateTime.EMPTY
    ) {}

    @Serializable
    data class Monitoring(
        @Serializable(with = KdbLocalDateTimeSerializer::class)
        var dt: LocalDateTime,
        var net: Network = Network(),
        /**
         * syntax:
         * ``runtime.www``
         */
        var version: String = "0.0",
        var data: Entry = Entry()
    ) {
        @Serializable
        data class Entry(
            val hw: Hw = Hw(),
            val ram: Ram = Ram(),
            val disk: Disk = Disk(),
            val temp: Temperature = Temperature(),
            val display: Display = Display()
        ) {}

        @Serializable
        data class Network(
            var online: Boolean = false,
            var kbps: Long = 0,
            var ping: Long = 0
        ) {}

        @Serializable
        data class Hw(
            var model: String = "",
            var device: String = "",
            var version: Int = 0,
            var fingerprint: String = "",
            var firmware: String = "",
            var manufacturer: String = "",
            var arch: String = "",
        ) {}

        @Serializable
        data class Ram(
            var size: String = "",
            var free: String = "",
        ) {}

        @Serializable
        data class Disk(
            var size: String = "",
            var free: String = "",
        ) {}

        @Serializable
        data class Temperature(
            var cpu: String = "",
            var gpu: String = "",
            var bat: String = "",
            var skin: String = "",
        ) {}

        @Serializable
        data class Display(
            var density: Float = 1F,
            var width: Int = 0,
            var height: Int = 0,
            var on: Boolean = false,
        ) {}

        companion object {}
    }

    @Serializable
    data class Log(
        var type: Int = 0,
        var data: String = ""
    ) {}
}